import { Navigate, Outlet } from 'react-router-dom';

import { maintenanceRoute } from 'constants.ts';
import { Loader } from '@/Components/Loader.tsx';
import { usePublicSettings } from 'Domains/settings/usePublicSettings.ts';

export function MaintenanceGuard() {
    const { maintenance, loading } = usePublicSettings();

    if (loading) {
        return <Loader />;
    }

    if (maintenance) {
        return <Navigate to={maintenanceRoute} replace />;
    }

    return <Outlet />;
}
